module.exports = __webpack_public_path__ + "img/Path 10 Copy@3x.461653b5.png";